export default __webpack_public_path__ + "static/media/location.c8f15cd0.svg";